var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{attrs:{"id":"app"}},[_c('loading-overlay-layer-legacy',{staticStyle:{"z-index":"9999"}}),_c('div',[_c('keep-alive',[_c('router-view')],1),_c('dialog-overlay')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }